module.exports = __webpack_public_path__ + "media/images/emblems/VicoMorcote-coat_of_arms-92f901ed23be3d789d517b9dbaa6245d.svg";